<script setup lang="ts">
import { useMmText } from './text'
withDefaults(defineProps<{ layout?: 'cards' | 'rows' | 'metrics' }>(), { layout: 'rows' })
const { t } = useMmText()
</script>
<template>
  <div class="mm-loading-state" :class="`mm-loading-${layout}`" role="status" :aria-label="t('common.loading')">
    <span class="mm-sr-only">{{ t('common.loading') }}</span>
    <div v-for="n in layout === 'cards' ? 2 : layout === 'metrics' ? 4 : 3" :key="n" class="mm-loading-item" aria-hidden="true"><div class="skel mm-loading-shape" /><div class="mm-loading-copy"><div class="skel mm-loading-line" /><div class="skel mm-loading-line short" /></div></div>
  </div>
</template>
<style scoped>
.mm-loading-state { display: grid; gap: var(--s-4); width: 100%; min-width: 0; padding-block: var(--s-6); }
.mm-loading-item { display: flex; align-items: center; gap: var(--s-4); min-width: 0; }
.mm-loading-shape { width: 52px; height: 52px; flex: none; }
.mm-loading-copy { flex: 1; min-width: 0; display: grid; gap: var(--s-3); }
.mm-loading-line { width: 75%; height: 14px; }.mm-loading-line.short { width: 45%; height: 12px; }
.mm-loading-cards { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.mm-loading-cards .mm-loading-item,.mm-loading-metrics .mm-loading-item { display: block; }
.mm-loading-cards .mm-loading-shape { width: 100%; height: auto; aspect-ratio: 1; }
.mm-loading-cards .mm-loading-copy { margin-top: var(--s-4); }
.mm-loading-metrics { grid-template-columns: repeat(4, minmax(0, 1fr)); }
.mm-loading-metrics .mm-loading-shape { width: 60%; height: 28px; margin-bottom: var(--s-4); }
@media(prefers-reduced-motion:reduce) { .skel { animation: none !important; } }
</style>
